<template>
  <div
    class="ui-map"
    :id="id"
    :style="{
      width: width,
      height: height,
    }"
  >
    <div :id="`${id}--map`" style="width:100%; height:100%;"></div>
    <Search
      v-if="searchbox"
      class="map-search"
      :width="width > 350 ? '300px' : `${width - 0}px`"
      :value.sync="searchVal"
      placeholder="Cari..."
      :valueAsObject="true"
      textKey="display_name"
      :dbref="{ method: 'get', url: this.parseUrl, parseData: this.parseData }"
    />
  </div>
</template>
<script>
import 'ol/ol.css'
// import ol from 'ol'
import { Map, View, Feature } from 'ol'
// import { boundingExtent } from 'ol/extent'
// import GeoJSON from 'ol/format/GeoJSON'
import VectorSource from 'ol/source/Vector'
import { fromLonLat, toLonLat } from 'ol/proj'
import { Icon as MapIcon, Style as MapStyle, Stroke, Fill } from 'ol/style'
import { Point as MapPoint, LineString } from 'ol/geom'
import TileLayer from 'ol/layer/Tile'
import MapVector from 'ol/source/Vector'
import LayerVector from 'ol/layer/Vector'
import OSM from 'ol/source/OSM'
import Search from './Search'

export default {
  components: {
    Search,
  },
  data: () => ({
    map: null,
    mapView: null,
    id: null,
    checker: null,
    searchVal: null,
    value: {},
    oldStrval: '',
    xMarkers: {},
  }),
  props: {
    width: {
      type: String,
      default: '250px',
    },
    height: {
      type: String,
      default: '250px',
    },
    lat: [String, Number],
    lon: [String, Number],
    strval: String,
    searchbox: {
      type: Boolean,
      default: true,
    },
    zoom: Number,
    markers: Array,
    layers: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    searchVal(val) {
      if (val) {
        console.log(val)
        this.mapView.setCenter(
          fromLonLat([parseFloat(val.lon), parseFloat(val.lat)])
        )
        this.mapView.setZoom(this.zoom || 13)
        this.$emit('update:lat', val.lat)
        this.$emit('update:lon', val.lon)
      }
    },
    markers(val) {
      this.clearMarkers()
      this.addMarkers(val)
      this.$emit('change', this.map)
    },
    layers() {
      this.drawLayes()
    },
    value(val) {
      if (val && val.lat && val.lon) {
        this.clearMarkers()
        this.addMarker(val)
        let zoom = this.zoom || this.mapView.getZoom()
        this.mapView.animate({
          center: fromLonLat([parseFloat(val.lon), parseFloat(val.lat)]),
          zoom: zoom < 13 ? 13 : zoom,
          duration: 700,
        })
        this.$emit('update:lat', val.lat)
        this.$emit('update:lon', val.lon)
        if (this.strval != `MULTIPOINT((${val.lat} ${val.lon}))`)
          this.$emit('update:strval', `MULTIPOINT((${val.lat} ${val.lon}))`)
      }
    },
    lat(val) {
      this.value = { lat: val, lon: this.lon }
    },
    strval(val) {
      if (val == `MULTIPOINT((${this.value.lat} ${this.value.lon}))` || !val) {
        return
      }

      let points = val
        .replace('MULTIPOINT(', '')
        .replace(/\)$/, '')
        .split(',')

      if (points.length == 1) {
        let p = points[0].replace(/[()]/, '').split(' ')
        this.value = { lat: p[0], lon: p[1] }
      } else {
        this.addLineString({
          name: 'strval',
          points: points,
        })
      }
    },
  },
  async created() {
    if (!window.uuid) window.uuid = 0
    this.id = 'map-' + window.uuid++
  },
  mounted() {
    this.mapView = new View({
      center: [12185696.496001672, -808222.1359253724],
      zoom: 8,
    })
    this.map = new Map({
      target: this.id + '--map',
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
      ],
      view: this.mapView,
    })
    this.map.on('click', evt => {
      var feature = this.map.forEachFeatureAtPixel(evt.pixel, function(
        feature
      ) {
        return feature
      })
      if (feature) {
        this.markerClick(feature.values_.data)
      } else {
        if (this.disabled) return
        var lonlat = toLonLat(evt.coordinate)
        this.value = { lat: lonlat[1], lon: lonlat[0] }
      }
    })
    this.map.on('pointermove', evt => {
      var feature = this.map.forEachFeatureAtPixel(evt.pixel, function(
        feature
      ) {
        return feature
      })
      if (feature) {
        this.map.getViewport().style.cursor = 'pointer'
        this.markerHover(feature.values_.data)
      } else {
        this.map.getViewport().style.cursor = ''
        this.markerHover(null)
      }
    })

    this.checker = setInterval(this.refreshIfNotExist.bind(this), 1000)
    if (this.markers) {
      this.addMarkers(this.markers)
    }
  },
  methods: {
    refreshIfNotExist() {
      if (document.querySelector(`#${this.id}--map .ol-layers canvas`)) {
        clearInterval(this.checker)
        this.$emit('ready', this.map)
      } else {
        this.map.updateSize()
        this.value = {
          lat: this.lat,
          lon: this.lon,
        }
      }
    },
    parseData(ret) {
      return ret.data
    },
    parseUrl(keyword) {
      return `https://nominatim.openstreetmap.org/search?q=${keyword}&format=json&countrycodes=id`
    },
    setCenter(val) {
      // this.mapView.setCenter(
      //   fromLonLat([parseFloat(val.lon), parseFloat(val.lat)])
      // )
      this.mapView.animate({
        center: fromLonLat([parseFloat(val.lon), parseFloat(val.lat)]),
        duration: 700,
      })
    },
    // LAYER
    drawLayes() {
      if (this.layers && this.layers.length)
        this.layers.forEach(m => {
          if (m.type == 'linestring') this.addLineString(m)
          else if (m.type == 'points') this.addLineString(m)
        })
    },
    getLayer(name) {
      let layer = null
      this.map.getLayers().forEach(l => {
        if (l.values_.name == name) layer = l
      })
      return layer
    },
    removeLayer(name) {
      let layer = this.getLayer(name)
      if (layer) this.map.removeLayer(layer)
      if (this.xMarkers[name]) delete this.xMarkers[name]
    },

    // MARKERS
    clearMarkers() {
      if (this.xMarkers['marker-default']) {
        this.xMarkers['marker-default'].clear()
      }
    },
    markerClick(data) {
      this.$emit('marker-click', data)
    },
    markerHover(data) {
      this.$emit('marker-hover', data)
    },
    addMarkers(val) {
      val.forEach(m => {
        this.addMarker(m)
      })
    },
    addMarker(m) {
      var marker = new Feature({
        data: m.title,
        onclick: m.onclick,
        geometry: new MapPoint(
          fromLonLat([parseFloat(m.lon), parseFloat(m.lat)])
        ),
      })
      if (typeof m.icon == 'object') {
        marker.setStyle(
          new MapStyle({
            image: new MapIcon(m.icon),
          })
        )
      } else {
        marker.setStyle(
          new MapStyle({
            image: new MapIcon({
              color: m.icon || m.color || 'white',
              crossOrigin: 'anonymous',
              src: m.iconSrc || '/img/icons/dot.png',
            }),
          })
        )
      }

      let markerName = 'marker-' + (m.layer ? m.layer : 'default')
      var markers = this.xMarkers[markerName]
      if (!markers) {
        // if (this.attr("tooltip")) {
        //   $(this).UI("createTooltip");
        //   this.map.on("pointermove", $.UI.map.showTooltip.bind(this));
        // }

        var markerVectorLayer = new LayerVector({
          name: 'marker-' + (m.layer ? m.layer : 'default'),
          source: new MapVector({
            features: [marker],
          }),
        })
        this.map.addLayer(markerVectorLayer)
        markerVectorLayer.setZIndex(1001)
        markers = markerVectorLayer.getSource()
      } else {
        markers.addFeature(marker)
      }
      this.xMarkers[markerName] = markers
      // this.data("markers" + (layerName ? "-" + layerName : ""), markers);
    },
    addLineString(opt) {
      let { name, points, multipoint } = opt
      if (!points && multipoint) {
        let mp = multipoint
          .replace('MULTIPOINT(', '')
          .replace(/\)$/, '')
          .split(',')

        points = mp.map(p => {
          return fromLonLat(p.replace(/[()]/g, '').split(' '))
        })
      } else if (points) {
        let px = points.map(p => {
          if (p && p.replace)
            return fromLonLat(p.replace(/[()]/g, '').split(' '))
          else if (p.x && p.y) return fromLonLat([p.x, p.y])
          else return fromLonLat([p[0], p[1]])
        })
        points = px
      }
      if (!points) return
      // let pmin = points[0].replace(/[()]/, '').split(' ')
      if (!this.value.lat && !this.strval) {
        let p = points[parseInt(points.length / 2)]
        this.mapView.animate({
          center: [parseFloat(p[0]), parseFloat(p[1])],
          zoom: 13,
          duration: 700,
        })
      }
      this.removeLayer(`linestring-${name}`)
      const layer = new LayerVector({
        name: `linestring-${name}`,
        source: new VectorSource({
          features: [
            new Feature({
              geometry: new LineString(points),
              name: `line-${name}`,
            }),
          ],
        }),
        style: [
          new MapStyle({
            stroke: new Stroke({
              color: 'blue',
              width: 3,
            }),
            fill: new Fill({
              color: 'rgba(0, 0, 255, 0.1)',
            }),
          }),
        ],
      })
      this.map.addLayer(layer)
    },
  },
}
</script>
<style lang="scss">
.ui-map {
  position: relative;
  .map-search {
    position: absolute;
    right: -10px;
    top: 10px;

    input {
      background: white;
    }
  }
  .ol-attribution {
    display: none;
  }
}
</style>
